import { useCallback, useEffect, useRef, useState } from "react";
import { motion } from "framer-motion";
import { usePath } from "../contexts/PathContext";
import { IoClose } from "react-icons/io5";
import MenuEachLink from "./MenuEachLink";

const menuContent = [
  {
    id: 1,
    img: "/assets/elements/menu-1.png",
    content: "最新消息",
    section: "news",
  },
  {
    id: 2,
    img: "/assets/elements/menu-2.png",
    content: "派派介紹",
    section: "introduce",
  },
  {
    id: 3,
    img: "/assets/elements/menu-3.png",
    content: "如何使用",
    section: "steps",
  },
  {
    id: 4,
    img: "/assets/elements/menu-4.png",
    content: "工作類別",
    section: "kinds-work",
  },
  {
    id: 5,
    img: "/assets/elements/menu-5.png",
    content: "常見問題",
    section: "questions",
  },
];
const merchantMenuContent = [
  {
    id: 1,
    img: "/assets/elements/menu-1.png",
    content: "最新消息",
    section: "news",
  },
  {
    id: 2,
    img: "/assets/elements/menu-2.png",
    content: "為何選擇我們",
    section: "introduce",
  },
  {
    id: 3,
    img: "/assets/elements/menu-3.png",
    content: "工作類別",
    section: "kinds-work",
  },
  {
    id: 4,
    img: "/assets/elements/menu-4.png",
    content: "合作夥伴",
    section: "partners",
  },
  {
    id: 5,
    img: "/assets/elements/menu-5.png",
    content: "常見問題",
    section: "questions",
  },
];

export function useIntersectionObserver(sections, setNowSection) {
  useEffect(() => {
    const isMobile = window.innerWidth < 1400;
    const options = {
      threshold: isMobile ? 0.1 : 0.3, // 區塊出現 30% 就觸發
      rootMargin: isMobile ? "0px 0px -50% 0px" : "-20% 0px -20% 0px", // 上下各縮小 20% 的觀察範圍
    };
    const useCallback = (entries) => {
      const visibleSections = entries
        .filter((entry) => entry.isIntersecting)
        .sort((a, b) => b.intersectionRatio - a.intersectionRatio);

      if (visibleSections.length > 0) {
        setNowSection(visibleSections[0].target.id);
      }
    };
    const observer = new IntersectionObserver(useCallback, options);
    sections.forEach(({ section }) => {
      const element = document.getElementById(section);
      if (element) observer.observe(element);
    });
    return () => observer.disconnect();
  }, [sections, setNowSection]);
}

export default function Menu({ onClose }) {
  const { isMerchantPage } = usePath();
  const menuRef = useRef(null);
  const [nowSection, setNowSection] = useState("");

  useEffect(() => {
    const handleOutsideClick = (e) => {
      if (menuRef.current && !menuRef.current.contains(e.target))
        onClose(false);
    };
    document.addEventListener("mousedown", handleOutsideClick);
    return () => {
      document.removeEventListener("mousedown", handleOutsideClick);
    };
  }, [onClose]);

  useIntersectionObserver(
    isMerchantPage ? merchantMenuContent : menuContent,
    setNowSection
  );

  const handleScrollTo = useCallback(
    (id) => {
      const section = document.getElementById(id);
      if (section) {
        onClose(false);
        window.history.pushState(null, "", `#${id}`);
        section.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    },
    [onClose]
  );

  const currentMenu = isMerchantPage ? merchantMenuContent : menuContent;
  const currentColor = isMerchantPage
    ? "var(--color-primary-blue)"
    : "var(--color-primary-orange)";

  return (
    <motion.div
      className="fixed inset-0 bg-[#00000071] z-50"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.2, delay: 0.3 }}
    >
      <motion.div
        style={{ position: "absolute", right: 0, top: 0, height: "100%" }}
        initial={{ x: "500px" }}
        animate={{ x: 0 }}
        exit={{ x: "500px" }}
        transition={{ type: "ease", duration: 0.3, delay: 0.3 }}
      >
        <ul ref={menuRef} className="menu">
          <button
            className="close-btn"
            onClick={() => onClose(false)}
            aria-label="關閉選單"
          >
            <IoClose size={24} />
          </button>

          {currentMenu.map((item) => (
            <MenuEachLink
              key={item.id}
              item={item}
              nowSection={nowSection}
              handleScrollTo={handleScrollTo}
              color={currentColor}
              isMerchantPage={isMerchantPage}
            ></MenuEachLink>
          ))}
        </ul>
      </motion.div>
    </motion.div>
  );
}
